'use strict';

bbw.directive.bbwPaginator = function() {
    var POS_PREV = -1;
    var POS_NEXT = 9999999999;
    return {
        restrict: 'EA',
        scope: {
            config: '=bbwPaginator'
        },
        templateUrl: bbw.templateUrl('paginator.html'),
        link: function(scope) {
            scope.items = [];
            function intval(value) {
                value = parseInt(value);
                if (isNaN(value) || value < 0) {
                    value = 0;
                }
                return value;
            }

            function updateItems() {
                scope.items.length = 0;
                var items = scope.items;
                if (scope.count > 1) {
                    var min = 0, max = scope.count - 1;

                    if (scope.prevnext) {
                        items.push({
                            'class': 'prevnext' + (scope.pos > 0 ? '' : ' disabled'),
                            clickable: scope.pos > 0,
                            label: '« Предыдущая',
                            pos: POS_PREV
                        });
                        items.push({
                            'class': 'prevnext' + (scope.pos < max ? '' : ' disabled'),
                            clickable: scope.pos < max,
                            label: 'Следующая »',
                            pos: POS_NEXT
                        });
                    }

                    if (scope.size == 0) {
                        items.push({
                            'class': 'current',
                            label: scope.pos + 1,
                            pos: scope.pos
                        });
                    } else {
                        var pos1 = scope.pos - 1, pos2 = scope.pos + 1;
                        items.push({
                            'class': 'current',
                            label: scope.pos + 1,
                            pos: scope.pos
                        });
                        var prevLength = 0;
                        while (items.length <= scope.size && items.length > prevLength) {
                            prevLength = items.length;
                            if (pos1 >= min) {
                                items.push({
                                    'class': 'link',
                                    clickable: true,
                                    label: pos1 + 1,
                                    pos: pos1--
                                });
                            }
                            if (items.length > scope.size) {
                                break;
                            }
                            if (pos2 <= max) {
                                items.push({
                                    'class': 'link',
                                    clickable: true,
                                    label: pos2 + 1,
                                    pos: pos2++
                                });
                            }
                        }
                    }
                }
                if (scope.size > 0) {
                    if (pos1 >= min + 1) {
                        if (pos1 == min + 1) {
                            items.push({
                                'class': 'link',
                                clickable: true,
                                label: pos1 + 1,
                                pos: pos1--
                            });
                        } else {
                            items.push({
                                'class': 'dots',
                                label: '',
                                pos: pos1--
                            });
                        }
                    }
                    if (pos1 >= min) {
                        items.push({
                            'class': 'link',
                            clickable: true,
                            label: min + 1,
                            pos: min
                        });
                    }
                    if (pos2 <= max - 1) {
                        if (pos2 == max - 1) {
                            items.push({
                                'class': 'link',
                                clickable: true,
                                label: pos2 + 1,
                                pos: pos2++
                            });
                        } else {
                            items.push({
                                'class': 'dots',
                                label: '',
                                pos: pos2++
                            });
                        }
                    }
                    if (pos2 <= max) {
                        items.push({
                            'class': 'link',
                            clickable: true,
                            label: max + 1,
                            pos: max
                        });
                    }
                }
                scope.items.sort(function(a, b) {
                    return a.pos - b.pos;
                });
            }

            var handler = function(cb, pos) {
                if (pos == POS_PREV) {
                    pos = scope.pos - 1;
                } else if (pos == POS_NEXT) {
                    pos = scope.pos + 1;
                }
                cb(pos);
            };

            function configure() {
                var config = scope.config;
                if (!angular.isObject(config)) {
                    return;
                }
                scope.count = intval(config.count);
                scope.pos = intval(config.pos);
                scope.handler = angular.isFunction(config.handler) ? handler.bind(null, config.handler) : undefined;
                scope.size = intval(config.size);
                if (isNaN(scope.size) || scope.size < 0) {
                    scope.size = 9;
                }
                scope.prevnext = !!config.prevnext;
                updateItems();
            }

            configure();
            scope.$watch('config', configure);
        }
    }
};
